import "./ask.css";
import Chat from "./pages/Chat";

// Route entry for the merchant-scoped /ask experience.
export function AskPage() {
  return <Chat />;
}

export default AskPage;
